/*
 * sort.js 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */
import {ACTIVE_PARTICIPANT_SORT, SORT_BY_NAME} from '../actions/types';

const sort = (state = {
    by: SORT_BY_NAME
}, action) => {

    switch (action.type) {

        case ACTIVE_PARTICIPANT_SORT:
            return {
                by: action.by
            };

        default:
            return state;

    }

};

export default sort;



// WEBPACK FOOTER //
// ./src/de/ergovia/reducers/sort.js